import React, { ReactNode } from "react";
import { Box, BoxProps, Flex, Text } from "@chakra-ui/react";

interface HrmsCardProps extends Omit<BoxProps, "title"> {
  title?: ReactNode;
  /** Right-aligned slot in the card header row. */
  actions?: ReactNode;
  children: ReactNode;
}

/**
 * Standard white surface used across HRMS pages — matches the card styling that
 * was previously copy-pasted into the dashboards.
 */
export const HrmsCard = ({
  title,
  actions,
  children,
  ...rest
}: HrmsCardProps) => (
  <Box
    bg="white"
    border="1px solid #e2e8f0"
    borderRadius="12px"
    p={4}
    {...rest}
  >
    {(title || actions) && (
      <Flex justify="space-between" align="center" mb={3} gap={3}>
        {title ? (
          <Text fontSize="14px" fontWeight="700" color="#495057" mb={0}>
            {title}
          </Text>
        ) : (
          <span />
        )}
        {actions}
      </Flex>
    )}
    {children}
  </Box>
);
